import React from 'react'
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EmailIcon from '@material-ui/icons/Email';

const useStyles = makeStyles((theme) => ({
    paperHight: {
        height: 150,
        display: 'row',
    },
    bigIconSize: {
        width: 70,
        height: 70,
        padding: '15px',
        border: '1px solid #000'
    },
    paper: {
        display: 'flex',
    },
    paddingTop: {
        paddingTop: '5px',
    },
    divPaddingTop: {
        paddingTop: '35px',
    },
    text: {
        color: '#3f51b5',
        fontFamily: 'Rajdhani',
    }
}));

function ImportantData() {
    const classes = useStyles();
    return (
        <div className={classes.divPaddingTop}>
            <div className={classes.paperHight}>
                <Paper className={classes.paper} elevation={3}>
                    <IconButton>
                        <PhoneIcon className={classes.bigIconSize} />
                    </IconButton>
                    <div >
                        <Typography className={classes.paddingTop} component="h6" variant="h6">
                            <span className={classes.text}>Phone</span>
                        </Typography>
                        <Typography component="p" variant="body2">
                            +8801793-783382 <br />
                            +8801303-287104
                        </Typography>
                    </div>
                </Paper>
            </div>
            <div className={classes.paperHight}>
                <Paper className={classes.paper} elevation={3}>
                    <IconButton>
                        <EmailIcon className={classes.bigIconSize} />
                    </IconButton>
                    <div>
                        <Typography className={classes.paddingTop} component="h6" variant="h6">
                            <span className={classes.text}> Email</span>
                        </Typography>
                        <Typography component="p" variant="body2">
                            akashahmed5724@gmail.com <br />
                            freealncerakash3@gmail.com
                        </Typography>
                    </div>
                </Paper>
            </div>
            <div className={classes.paperHight}>
                <Paper className={classes.paper} elevation={3}>
                    <IconButton>
                        <LocationOnIcon className={classes.bigIconSize} />
                    </IconButton>
                    <div>
                        <Typography className={classes.paddingTop} component="h6" variant="h6">
                            <span className={classes.text}> Location</span>
                        </Typography>
                        <Typography component="p" variant="body2">
                            Sakhipur , Tangail | Sakhipur-1950
                        </Typography>
                    </div>
                </Paper>
            </div>
        </div>
    )
}

export default ImportantData
